import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getBranches } from "../../actions/branchActions";
import { getInstitutions } from "../../actions/institutionActions";
import { getGrades } from "../../actions/gradeActions";
import { getMember, updateMember } from "../../actions/memberActions";
import { getSites } from "../../actions/siteActions";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Select from "react-select";
import classnames from "classnames";

class EditMember extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      firstname: "",
      surname: "",
      nationalId: "",
      gender: "",
      maritalStatus: "",
      dob: "",
      cellNumber: "",
      email: "",
      town: "",
      nextOfKin: "",
      nokPhone: "",
      relationship: "",
      grade: "",
      basicWage: "",
      jobTitle: "",
      currentBranch: "",
      status: "",
      //stoporder details
      stopId: "",
      stoporders: "",
      stoporder: "",
      stopOrderNumber: "",
      dateEmployed: "",
      dateJoined: "",
      recruitmentBranch: "",
      institution: "",
      company:"",
      stoporders1: null,
      institutionList: "",
      branchList: "",
      site: "",
      errors: {},
      position: "center",
      displayBasic: false,
    };

    this.saveMember = this.saveMember.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleGradeChange = this.handleGradeChange.bind(this);
    this.handleInstitutionChange = this.handleInstitutionChange.bind(this);
    this.handleCurrentBranchChange = this.handleCurrentBranchChange.bind(this);
    this.handleRecruitmentBranchChange = this.handleRecruitmentBranchChange.bind(this)
    this.handleSiteChange = this.handleSiteChange.bind(this);

    this.deleteStoporder = this.deleteStoporder.bind(this);
    this.addStopOrder = this.addStopOrder.bind(this);
    this.handleStopOrderDetailsChange = this.handleStopOrderDetailsChange.bind(
      this
    );
    this.updateStoporder = this.updateStoporder.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidMount() {
    this.props.getBranches();
    this.props.getGrades();
    const { memberId } = this.props.match.params;
    this.props.getMember(memberId, this.props.history);
    this.props.getInstitutions();
    this.props.getSites();
  }
  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    const {
      id,
      firstname,
      surname,
      nationalId,
      gender,
      maritalStatus,
      dob,
      cellNumber,
      email,
      town,
      nextOfKin,
      nokPhone,
      relationship,
      grade,
      basicWage,
      jobTitle,
      currentBranch,
      status,
      site,
      stoporders,
    } = nextProps.member;
    this.setState({
      id,
      firstname,
      surname,
      nationalId,
      gender,
      maritalStatus,
      dob,
      cellNumber,
      email,
      town,
      nextOfKin,
      nokPhone,
      relationship,
      grade,
      basicWage,
      jobTitle,
      currentBranch,
      status,
      site,
      stoporders,
    });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleStopOrderDetailsChange(val) {
    let { stoporder } = this.state;
    const name = val.target.name;
    const value = val.target.value;
    stoporder[name] = value;
    this.setState({ stoporder });
  }

  handleGradeChange(val) {
    this.setState({ grade: val });
  }
  handleCurrentBranchChange(val) {
    this.setState({ currentBranch: val });
  }

  handleRecruitmentBranchChange(val) {
    this.setState({ recruitmentBranch: val });
  }

  handleInstitutionChange(val) {
    this.setState({ institution: val });
  }
  handleSiteChange(val) {
    this.setState({ site: val });
  }
  addStopOrder() {
    //construct stoporder object
    let tempSO = {
      stopOrderNumber: this.state.stopOrderNumber,
      dateEmployed: this.state.dateEmployed,
      dateJoined: this.state.dateJoined,
      recruitmentBranch: this.state.recruitmentBranch,
      institution: this.state.institution,
      site: this.state.site
    };
    this.state.stoporders.push(tempSO);
    this.setState({ stopOrderNumber: "" });
  }

  saveMember = (e) => {
    e.preventDefault();
    let member = {
      id: this.state.id,
      firstname: this.state.firstname,
      surname: this.state.surname,
      nationalId: this.state.nationalId,
      gender: this.state.gender,
      maritalStatus: this.state.maritalStatus,
      dob: this.state.dob,
      cellNumber: this.state.cellNumber,
      email: this.state.email,
      town: this.state.town,
      nextOfKin: this.state.nextOfKin,
      nokPhone: this.state.nokPhone,
      relationship: this.state.relationship,
      grade: this.state.grade,
      basicWage: this.state.basicWage,
      jobTitle: this.state.jobTitle,
      currentBranch: this.state.currentBranch,
      status: this.state.status,
      stoporders: this.state.stoporders,
     
    };

    this.props.updateMember(member, this.props.history);
  };

  cancel() {
    this.props.history.push("/member-list");
  }

  editStoporder = (stoporderTemp) => {
    this.setState({
      stopId: stoporderTemp.id,
      stopOrderNumber: stoporderTemp.stopOrderNumber,
      dateEmployed: stoporderTemp.dateEmployed,
      dateJoined: stoporderTemp.dateJoined,
      recruitmentBranch: stoporderTemp.recruitmentBranch,
      institution: stoporderTemp.institution,
      site: stoporderTemp.site
    });

    this.onClick("displayBasic");
  };

  updateStoporder(name) {
    let stoporder = {
      id: this.state.stopId,
      stopOrderNumber: this.state.stopOrderNumber,
      dateEmployed: this.state.dateEmployed,
      dateJoined: this.state.dateJoined,
      recruitmentBranch: this.state.recruitmentBranch,
      institution: this.state.institution,
      site: this.state.site
    };

    const index = this.state.stoporders.findIndex(
      (stp) => stp.id === stoporder.id
    );
    const stoporders = [...this.state.stoporders];
    stoporders[index] = stoporder;
    this.setState({ stoporders });

    this.onHide(name);
  };

  deleteStoporder = (stoporderNumber) => {
    const tempSO = [...this.state.stoporders];
    const index = tempSO.findIndex(
      (stp) => stp.stopOrderNumber === stoporderNumber
    );

    if (index !== -1) {
      tempSO.splice(index, 1);
      this.setState({
        stoporders: tempSO
      });
    }
  }

  onClick(name, position) {
    let state = {
      [`${name}`]: true,
    };

    if (position) {
      state = {
        ...state,
        position,
      };
    }
    this.setState(state);
  }

  onHide(name) {
    this.setState({ [`${name}`]: false });
  }

  renderFooter(name) {
    return (
      <div>
        <Button
          label="Cancel"
          icon="pi pi-times"
          onClick={() => this.onHide(name)}
          className="p-button-text"
        />
        <Button
          label="Update"
          icon="pi pi-check"
          onClick={() => this.updateStoporder(name)}
          autoFocus
        />
      </div>
    );
  }

  render() {
    const { errors } = this.state;
    const { grades } = this.props.grade;
    const { branches } = this.props.branch;
    const { institutions } = this.props.institution;
    const { stoporders } = this.props.member;
    const { sites } = this.props.site;

    const stoporderList =
      stoporders &&
      stoporders.map((stoporder) => {
        return (
          <tr key={stoporder.stopOrderNumber}>
            <td>{stoporder.stopOrderNumber}</td>
            <td>{stoporder.dateEmployed}</td>
            <td>{stoporder.dateJoined}</td>
            <td>{stoporder.dateTerminated}</td>
            <td>{stoporder.recruitmentBranch.branchName}</td>
            <td>{stoporder.institution.institutionName}</td>
            <td>{stoporder.site.siteName}</td>
            <td>{stoporder.company}</td>
            <td>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.editStoporder(stoporder)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => this.deleteStoporder(stoporder.stopOrderNumber)}
                >
                  Delete
                </button>
              </div>
            </td>
          </tr>
        );
      });

    return (
      <div className="container">

        <div className="card m-auto  border-primary shadow-lg rounded p-3">
          <h5 className="display-4 text-center">Edit Member</h5>
          <p className="lead text-center">Alter Member Details</p>
          <hr />
          {errors.message && (
            <div className="alert alert-danger text-center" role="alert">
              {errors.message}
            </div>
          )}

          <h5 className="display-5 text-center bg-info">
            Personal Details
          </h5>

          <form>

            <div className="row m-3">
              <div className="form-group col-sm-4 m-auto">
                <label>Firstname**</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.firstname,
                  })}
                  type="text"
                  name="firstname"
                  id="firstname"
                  value={this.state.firstname || ""}
                  onChange={this.onChange}
                  placeholder="Firstname"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">{errors.firstname}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Surname**</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.surname,
                  })}
                  type="text"
                  name="surname"
                  id="surname"
                  value={this.state.surname || ""}
                  onChange={this.onChange}
                  placeholder="Surname"
                />
                {errors.surname && (
                  <div className="invalid-feedback">{errors.surname}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>National Id**</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.nationalId,
                  })}
                  type="text"
                  name="nationalId"
                  id="nationalId"
                  value={this.state.nationalId || ""}
                  onChange={this.onChange}
                  placeholder="National Id"
                />
                {errors.nationalId && (
                  <div className="invalid-feedback">{errors.nationalId}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Gender</label>
                <select
                  className="form-control"
                  value={this.state.gender}
                  onChange={this.onChange}
                  name="gender"
                >
                  <option value={"M"}>M</option>
                  <option value={"F"}>F</option>
                </select>
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Marital Status</label>
                <select
                  className="form-control"
                  onChange={this.onChange}
                  value={this.state.maritalStatus || ""}
                  name="maritalStatus"
                >
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Widowed">Widowed</option>
                </select>
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Date Of Birth</label>
                <input
                  type="date"
                  className="form-control form-control-lg"
                  name="dob"
                  onChange={this.onChange}
                  value={this.state.dob || ""}
                />
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Mobile Number</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.cellNumber,
                  })}
                  type="text"
                  name="cellNumber"
                  id="cellNumber"
                  value={this.state.cellNumber || ""}
                  onChange={this.onChange}
                  placeholder="Mobile Number"
                />
                {errors.cellNumber && (
                  <div className="invalid-feedback">{errors.cellNumber}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Email</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.email,
                  })}
                  type="text"
                  name="email"
                  id="email"
                  value={this.state.email || ""}
                  onChange={this.onChange}
                  placeholder="Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Town</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.town,
                  })}
                  type="text"
                  name="town"
                  id="town"
                  value={this.state.town || ""}
                  onChange={this.onChange}
                  placeholder="Town"
                />
                {errors.town && (
                  <div className="invalid-feedback">{errors.town}</div>
                )}
              </div>

              <div className="form-group col-sm-12">
                <label>Current Branch</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleCurrentBranchChange}
                  getOptionLabel={(branch) => `${branch.branchName}`}
                  isOptionSelected={true}
                  value={this.state.currentBranch}
                  options={branches}
                />
              </div>
            </div>
            <hr />
            <h5 className="display-5 text-center bg-info">
              Next Of Kin Details
            </h5>
            <div className="row m-3">
              <div className="form-group col-sm-4 m-auto">
                <label>Next Of Kin</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.nextOfKin,
                  })}
                  type="text"
                  name="nextOfKin"
                  id="nextOfKin"
                  value={this.state.nextOfKin || ""}
                  onChange={this.onChange}
                  placeholder="Next Of Kin"
                />
                {errors.nextOfKin && (
                  <div className="invalid-feedback">{errors.nextOfKin}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Next Of Kin Phone</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.nokPhone,
                  })}
                  type="text"
                  name="nokPhone"
                  id="nokPhone"
                  value={this.state.nokPhone || ""}
                  onChange={this.onChange}
                  placeholder="Next Of Kin Phone"
                />
                {errors.nokPhone && (
                  <div className="invalid-feedback">{errors.nokPhone}</div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Relationship</label>
                <select
                  className="form-control"
                  onChange={this.onChange}
                  value={this.state.relationship || ""}
                  name="relationship"
                >
                  <option value="Spouse">Spouse</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Sister">Sister</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Brother">Brother</option>
                  <option value="Cousin">Cousin</option>
                  <option value="Aunt">Aunt</option>
                  <option value="Uncle">Uncle</option>
                  <option value="Brother">Brother</option>
                  <option value="Sister">Sister</option>
                  <option value="Friend">Friend</option>
                  <option value="Pastor">Pastor</option>
                </select>
              </div>
            </div>

            <hr />
            <h5 className="display-5 text-center bg-info">
              Employment Details
            </h5>
            <div className="row m-3">
              <div className="form-group col-sm-4 m-auto">
                <label>Grade</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleGradeChange}
                  getOptionLabel={(grade) => `${grade.gradeName}`}
                  isOptionSelected={true}
                  value={this.state.grade}
                  options={grades}
                />
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Occupation</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.jobTitle,
                  })}
                  type="text"
                  name="jobTitle"
                  id="jobTitle"
                  value={this.state.jobTitle || ""}
                  onChange={this.onChange}
                  placeholder="Occupation"
                />
                {errors.jobTitle && (
                  <div className="invalid-feedback">{errors.jobTitle}</div>
                )}
              </div>
            </div>
            <hr />
            <h5 className="display-5 text-center bg-info">
              Stop Order Details
            </h5>
            <div className="row m-3">
              <div className="form-group col-sm-4 m-auto">
                <label>Stop Order Number</label>
                <input
                  className={classnames("form-control", {
                    "is-invalid": errors.stopOrderNumber,
                  })}
                  type="number"
                  name="stopOrderNumber"
                  id="stopOrderNumber"
                  value={this.state.stopOrderNumber}
                  onChange={this.onChange}
                  placeholder="Stop Order Number"
                />
                {errors.stopOrderNumber && (
                  <div className="invalid-feedback">
                    {errors.stopOrderNumber}
                  </div>
                )}
              </div>

              <div className="form-group col-sm-4 m-auto">
                <label>Date Of Employment</label>
                <input
                  type="date"
                  className="form-control form-control-lg"
                  name="dateEmployed"
                  onChange={this.onChange}
                  value={this.state.dateEmployed || ""}
                />
              </div>

              <div className="form-group col-sm-4 ">
                <label>Joining Date</label>
                <input
                  type="date"
                  className="form-control form-control-lg"
                  name="dateJoined"
                  onChange={this.onChange}
                  value={this.state.dateJoined || ""}
                />
              </div>
              <div className="form-group col-sm-4 ">
                <label>Institution</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleInstitutionChange}
                  getOptionLabel={(institution) =>
                    `${institution.institutionName}`
                  }
                  isOptionSelected={true}
                  value={this.state.institution}
                  options={institutions}
                />
              </div>
              <div className="form-group col-sm-4">
                <label>Recruitment Branch</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleRecruitmentBranchChange}
                  getOptionLabel={(branch) => `${branch.branchName}`}
                  isOptionSelected={true}
                  value={this.state.branch}
                  options={branches}
                />
              </div>
              <div className="form-group col-sm-4">
                    <label>Site</label>
                    <Select
                      className="react-selectcomponent"
                      classNamePrefix="name-select"
                      onChange={this.handleSiteChange}
                      getOptionLabel={(site) => `${site.siteName}`}
                      isOptionSelected={true}
                      value={this.state.site}
                      options={sites}
                      required={true}
                    />
                  </div>
              <button
                type="button"
                className="btn btn-primary btn-block mt-4 mb-4"
                onClick={this.addStopOrder}
              >
                Save Stoporder
              </button>
            </div>
            <div className="row m-3">
              <table className="table table-striped table-sm ml-4 mr-2">
                <thead>
                  <tr>
                    <th>S/O Number</th>
                    <th>Date Employed</th>
                    <th>Date Joined</th>
                    <th>Date Terminated</th>
                    <th>Branch</th>
                    <th>Institution</th>
                    <th>Site</th>
                    <th>Company</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>{stoporderList}</tbody>
              </table>
            </div>

            <div className="form-group">
              <div className="row m-3">
                <div className="col-sm-6">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block mt-4"
                    onClick={this.saveMember}
                  >
                    Save
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-secondary btn-block mt-4"
                    onClick={this.cancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>


          {this.state.displayBasic && (<div className="dialog-demo">
            <div className="card">
              <h5>Edit Stoporder</h5>(
              <Dialog
                header="Edit Stoporder"
                visible={this.state.displayBasic}
                style={{ width: "50vw" }}
                footer={this.renderFooter("displayBasic")}
                onHide={() => this.onHide("displayBasic")}
              >
                <div className="row m-3">
                  <div className="form-group col-sm-6 m-auto">
                    <label>Stop Order Number</label>
                    <input
                      className="form-control"
                      type="number"
                      name="stopOrderNumber"
                      id="stopOrderNumber"
                      value={this.state.stopOrderNumber}
                      onChange={this.onChange}
                      placeholder="Stop Order Number"
                    />
                  </div>
                  <div className="form-group col-sm-6 ">
                    <label>Institution</label>
                    <Select
                      className="react-selectcomponent"
                      classNamePrefix="name-select"
                      onChange={this.handleInstitutionChange}
                      getOptionLabel={(institution) =>
                        `${institution.institutionName}`
                      }
                      isOptionSelected={true}
                      value={this.state.institution}
                      options={institutions}
                    />
                  </div>
                  <div className="form-group col-sm-6">
                    <label>Recruitment Branch</label>
                    <Select
                      className="react-selectcomponent"
                      classNamePrefix="name-select"
                      onChange={this.handleRecruitmentBranchChange}
                      getOptionLabel={(branch) => `${branch.branchName}`}
                      isOptionSelected={true}
                      value={this.state.recruitmentBranch}
                      options={branches}
                    />
                  </div>
                  <div className="form-group col-sm-6">
                    <label>Site</label>
                    <Select
                      className="react-selectcomponent"
                      classNamePrefix="name-select"
                      onChange={this.handleSiteChange}
                      getOptionLabel={(site) => `${site.siteName}`}
                      isOptionSelected={true}
                      value={this.state.site}
                      options={sites}
                      required={true}
                    />
                  </div>
                  <div className="form-group col-sm-6 m-auto">
                    <label>Date Of Employment</label>
                    <input
                      type="date"
                      className="form-control "
                      name="dateEmployed"
                      onChange={this.onChange}
                      value={this.state.dateEmployed || ""}
                    />
                  </div>

                  <div className="form-group col-sm-6 ">
                    <label>Joining Date</label>
                    <input
                      type="date"
                      className="form-control "
                      name="dateJoined"
                      onChange={this.onChange}
                      value={this.state.dateJoined || ""}
                    />
                  </div>
                </div>
              </Dialog>

            </div>
          </div>)}
        </div>
      </div>
    );
  }
}

EditMember.propTypes = {
  updateMember: PropTypes.func.isRequired,
  getGrades: PropTypes.func.isRequired,
  getInstitutions: PropTypes.func.isRequired,
  getBranches: PropTypes.func.isRequired,
  getSites: PropTypes.func.isRequired,
  getMember: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  grade: state.grade,
  branch: state.branch,
  institution: state.institution,
  member: state.member.member,
  site: state.site,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  updateMember,
  getGrades,
  getBranches,
  getMember,
  getSites,
  getInstitutions,
})(EditMember);
